import axios from 'axios'
import { store } from 'store/store'

export interface Token {
  authenticated: boolean
  created: string
  expiration: string
  accessToken: string
}

const headers = {
  'Cache-Control': 'no-cache',
  'Content-Type': 'application/json',
  'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_BASE_SUBSCRIPTION}`,
  'X-Client-Application-Name': `${process.env.REACT_APP_NAME}`,
  'X-Client-Application-Version': `${process.env.REACT_APP_VERSION}`,
} as const

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: headers,
})

api.interceptors.request.use(
  (request) => {
    const urlTest = /(auth|autenticacao)/.test(request.url as string)
    if (urlTest) {
      store.dispatch({ payload: true, type: 'structure/setGlobalLoading' })
      return request
    } else {
      const { token } = store.getState().auth

      if (token?.accessToken && request.headers) {
        request.headers['Authorization'] = `Bearer ${token?.accessToken}`
      }

      store.dispatch({ payload: true, type: 'structure/setGlobalLoading' })
      return request
    }
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    store.dispatch({ payload: false, type: 'structure/setGlobalLoading' })
    return response
  },
  (error) => {
    store.dispatch({ payload: false, type: 'structure/setGlobalLoading' })
    return Promise.reject(error)
  },
)
export default api
